import React from 'react';
import UserDateInformationContainer from '../../../common/UserDateInformationContainer';

type Props = {
  checkedMode: string;
  setFieldValue: (name: string, value: any) => void;
  initialData: any;
  setValidateOnChange: (arg: boolean) => void;
  values: any;
  formikProps: any;
  errors: any;
};

const ICheckedInformationContainer = ({
  checkedMode,
  setFieldValue,
  initialData,
  setValidateOnChange,
  values,
  formikProps,
  errors,
}: Props) => {
  return (
    <UserDateInformationContainer
      id="inventoryUserDateInformationContainer"
      accordionTitle={`inventory.details.page.${checkedMode}.checked.inf.container.title`}
      accordionTooltip={`inventory.details.page.${checkedMode}.checked.inf.container.tooltip`}
      userLabel="inventory.details.page.checked.inf.container.check.user.input"
      userName="checkUser"
      dteLabel="inventory.details.page.checked.inf.container.check.dte.input"
      dteName="checkDte"
      openDirection="up"
      renderDefaultButtons={false}
      disabled={true}
      closable={false}
      isInventory={true}
      initialData={initialData}
      setFieldValue={setFieldValue}
      setValidateOnChange={setValidateOnChange}
      values={values}
      formikProps={formikProps}
      errors={errors}
    />
  );
};

ICheckedInformationContainer.defaultProps = {
  checkedMode: 'last',
};

export default React.memo(ICheckedInformationContainer);
